import LoadingSkeleton from "@shared/LoadingSkeleton";

const ProfileTableSkeleton = () => {
  return (
    <div className="p-2">
      <LoadingSkeleton lines={1} lineHeight="30px" width="8%" shape="rectangle" margin={"1rem 0 0 0"} />
      <LoadingSkeleton lines={13} lineHeight="30px" width="100%" shape="rectangle" />
    </div>
  );
};

export default ProfileTableSkeleton;
